"use strict";

import React, {useState} from "react";
import AutoSuggest from 'react-autosuggest';

const FormAutoSuggest = ({inputValue='', onInputChange=()=>{}, onInputBlur=()=>{}, inputName='auto_suggest',
                         placeholder='', suggestions=[], setSuggestionRequestValue=()=>{},
                         onSuggestionSelected=()=>{}, getFocusedSuggestionValue=()=>{},
                         clearSuggestions=()=>{}, renderSuggestion=()=>{},})=>{
    return (
      <AutoSuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={({value}) => {
              setSuggestionRequestValue(value);
          }}
          onSuggestionsClearRequested={clearSuggestions}
          getSuggestionValue={getFocusedSuggestionValue}
          onSuggestionSelected={onSuggestionSelected}
          renderSuggestion={renderSuggestion}
          inputProps={{
              name: inputName,
              placeholder: placeholder,
              value: inputValue,
              onChange: (e, {newValue}) => {
                  onInputChange(newValue);
              },
              onBlur: onInputBlur,
          }} />
  );
};

export default FormAutoSuggest;
